import gql from 'graphql-tag';

export default gql`
mutation createForm($obj: CreateFormInput!) {
  createForm(object: $obj) {
    newFormId
  }
}
`;
